import React, { PureComponent } from 'react';

import { setDisplayName } from '../../../../shared/react-hocs/hoc-helpers';

import ProgressBar from '../progress-bar';
import Error from '../error';

function withPageContainer(WrappedComponent) {
	class WithPageContainer extends PureComponent {
		componentDidMount() {
			this.props.fetchData(this.props);
		}

		render() {
			// Error must be before ProgressBar!
			if (this.props.error) {
				return (
					<Error {...this.props} />
				);
			}

			if (!(this.props.data || this.props.rows) || this.props.progressBar) {
				return (
					<ProgressBar />
				);
			}

			return (
				<WrappedComponent {...this.props} />
			);
		}
	}

	setDisplayName(WithPageContainer, WrappedComponent);

	return WithPageContainer;
}

export default withPageContainer;


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/page-container/with-page-container.js